<template>
    <div>
        <span class="label published" v-if="!endAt && internalValue == 1">Publié</span>
        <span class="label expired_soon" v-if="endAt && internalValue == 1" :title="'Expiration le ' + formatDate(endAt)">
            Expire <datetime v-model="endAt" :human="true"></datetime>
        </span>
        <span class="label unpublished" v-if="internalValue == 0">Non publié</span>
        <span class="label expired" v-if="internalValue == -1"  :title="'Terminé le ' + formatDate(endAt)">Terminé <datetime v-model.number="endAt" :human="true"></datetime></span>
        <span class="label soon" v-if="internalValue == 2" :title="'Programmé le ' + formatDate(startAt)">
            Programmé <datetime v-model="startAt" :human="true"></datetime>
        </span>
    </div>
</template>

<script>
    export default {
        name: 'Published',
        props: ['value','label','name','placeholder','dateStart','dateEnd'],
        data: function () {
            return {
                internalValue: ''
            }
        },
        created: function() {
            this.internalValue = this.value;
            this.endAt = this.dateEnd;
            this.startAt = this.dateStart;
        },
        methods: {
            formatDate: function(value){
                //moment(value).tz('Europe/Zurich').format('DD.MM.YYYY HH:mm');
              if( value ){
                return moment(value).format('DD.MM.YYYY HH:mm');
              }
              return null;
            }
        },
        watch: {
          'value'(newVal, oldVal) {
              this.internalValue = newVal
          },
          'dateEnd'(newVal, oldVal) {
            this.endAt = newVal;
          },
          'dateStart'(newVal, oldVal) {
          this.startAt = newVal;
          }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Published.vue